//Check if item is an object, is not an array   and is not null
export default function isObject(item) {
      return (typeof item === "object" && !Array.isArray(item) && item !== null);
};


// WEBPACK FOOTER //
// ./src/utils/general.js